module.exports = __webpack_public_path__ + "static/media/slack.433473f5.png";